import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/queryClient'
import { GlobalToaster } from '@/components/ui/GlobalToaster'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
    <GlobalToaster />
  </QueryClientProvider>
);
